import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthStore, UrlUtils } from '@vectord/utils';

import normalizeResponse from 'utils/normalizeResponse';

const baseQuery = fetchBaseQuery({
  baseUrl: UrlUtils.join(process.env.REACT_APP_API_BASE, 'v3/'),
  prepareHeaders: (headers) => {
    const { jwt } = AuthStore.get();
    if (jwt) {
      headers.set('X-User-Token', jwt);
    }
    return headers;
  },
});

const permissionsService = createApi({
  reducerPath: 'permissionsApi',
  tagTypes: ['Permission'],
  baseQuery: async function (...args) {
    const response = await baseQuery(...args);
    if (response.meta.response.ok) {
      return {
        ...response,
        data: normalizeResponse(response.data),
      };
    } else {
      return response;
    }
  },
  endpoints: (build) => ({
    getPermissions: build.query({
      query: () => ({
        method: 'GET',
        url: 'permissions',
      }),
      keepUnusedDataFor: 60 * 60 * 24, // Cache data for 24 hour
      providesTags: (result, error) => (error ? [] : ['Permission']),
    }),
  }),
  overrideExisting: false,
});

export const { useGetPermissionsQuery } = permissionsService;

export default permissionsService;
